import * as Sentry from '@sentry/browser';
import {MAIL_API_KEY, MAIL_SENDER} from 'config';

export const upload = async ({dirPath, filename, file, accessToken}) => {
	// Create directory unless it already exists
	await createDirectory({path: dirPath, accessToken});

	// Upload file to the directory
	const formData = new FormData();
	formData.append('file', file);
	formData.append('q', JSON.stringify({path: `${dirPath}/${filename}`}));

	const res = await uploadFile({formData, accessToken});

	if (!res.ok) {
		const body = await res.json();
		const err =
			body?.e?.m && body.e.m.includes('already exists')
				? 'Samanniminen tiedosto on jo olemassa'
				: 'Tallennus epäonnistui';
		throw new Error(err);
	}

	return res;
};

export const createDirectory = ({path, accessToken}) => {
	const headers = new Headers();
	headers.append('Accept', 'application/json');
	headers.append('Content-Type', 'application/json');
	headers.append('Authorization', 'Bearer ' + accessToken);

	return fetch(
		'https://api.showellapp.com/api/file-system.directory/create-if-not-exists',
		{
			headers,
			method: 'POST',
			body: JSON.stringify({path, createMissingParents: true}),
		},
	);
};

export const uploadFile = ({formData, accessToken}) => {
	return fetch('https://api.showellapp.com/api/file-system.file-http/upload', {
		headers: [['Authorization', 'Bearer ' + accessToken]],
		method: 'POST',
		body: formData,
	});
};

export const sendEmail = async ({
	subject,
	html,
	plainText,
	recipients = [],
	attachments = [],
	inlines,
}) => {
	const body = JSON.stringify({
		api_key: MAIL_API_KEY,
		sender: MAIL_SENDER,
		to: recipients,
		subject: subject,
		text_body: plainText,
		html_body: `<!doctype html><html><head><meta charset="utf-8"><title></title></head><body>${html}</body></html>`,
		attachments,
		inlines,
	});

	return fetch('https://api.smtp2go.com/v3/email/send', {
		method: 'POST',
		headers: {'Content-Type': 'application/json'},
		body,
	})
		.then((response) => {
			if (response.ok) {
				return response.json();
			}
			return Promise.reject(response);
		})
		.catch((response) => {
			response.json().then((result) => {
				const errData = JSON.stringify(result);
				console.warn(errData);
				Sentry.captureException(new Error('Sending email failed'), (scope) => {
					scope.setContext('result', {data: errData});
				});
			});
		});
};
